import Default from './components/Default.vue';
import NumberCurrency from './components/Number.vue';
import Color from './components/Color.vue';
import Geo from './components/Geo.vue';
import Password from './components/Password.vue';
import Ranking from './components/Ranking.vue';
import DefaultSelect from '../componentsToQuestions/DefaultSelect.vue';
import Slider from './components/Slider.vue';
import Date from './components/Date.vue';
import Multiple from './components/Multiple.vue';
import RadioOther from './components/RadioOther.vue';
import MultiOther from './components/MultiOther.vue';
import Radio from './components/Radio.vue';
import Email from './components/Email.vue';
import Switch_ from './components/Switch.vue';
import Label from './components/Label.vue';
import Viewer from './components/Viewer.vue';
import Subformulario from './components/Subformulario.vue';
import Link from './components/Link.vue';
import Action from './components/Action.vue';
import Paragraph from './components/Paragraph.vue';
import Url_ from './components/Url.vue';
import Map from './components/Map.vue';
import OriginStandar from './components/OrigenStandar.vue';
import OriginBase from './components/OrigenBase.vue';
import OriginSelect from './components/OriginSelect.vue';
import Scala from './components/Scala.vue';
import ListInformative from './components/ListaInformativa.vue';
import File from './components/File.vue';

export const AllComponents = { 
	Action,
	Default, 
	NumberCurrency, 
	Color, 
	Geo, 
	DefaultSelect, 
	Password, 
	Ranking, 
	Slider, 
	Date,
	Multiple,
	RadioOther,
	MultiOther,
	Radio,
	Email,
	Switch_,
	Label,
	Viewer,
	Subformulario,
	Link,
	Paragraph,
	Url_,
	Map,
	OriginStandar,
	OriginBase,
	OriginSelect,
	Scala,
	ListInformative,
	File
}
